























import { defineComponent, ref } from '@vue/composition-api'
import Panel from './panel.vue'
import planIndex1 from '@/assets/plan-index-1.png'
import planIndex2 from '@/assets/plan-index-2.png'
import planIndex3 from '@/assets/plan-index-3.png'

export default defineComponent({
  name: 'plan',
  components: {
    Panel
  },
  setup() {
    const list = ref([{
      title: '百万医疗保障',
      desc: '覆盖社保外用药，缓解就医经济压力',
      image: planIndex1 + ''
    }, {
      title: '意外伤害保障',
      desc: '覆盖日常生活，保障日常意外风险',
      image: planIndex2 + ''
    }, {
      title: '住院津贴保障',
      desc: '住院津贴一次付，给予住院期间关怀',
      image: planIndex3 + ''
    }])
    return {
      list
    }
  }
})
